import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

// Único ponto do sistema que deve importar @tippyjs/react diretamente - todo
// tooltip passa por aqui.
//
// `tema`: "dark" (padrão) ou "light" (bolha clara/texto escuro, ver
// data-theme~='light' em styles/global.js). "dark" não tem CSS próprio
// nenhum - só deixa a bolha escura/texto branco NATIVA do Tippy aparecer
// (.tippy-box{background:#333;color:#fff} do tippy.css), sem nenhum
// data-theme batendo com a regra de styles/global.js. `theme` (cru, valor
// repassado direto pro Tippy) continua aceito por compatibilidade com quem
// já chamava "light"/"tooltip" antes de `tema` existir - vale por cima de
// `tema` quando passado.
const Tooltip = ({
  children,
  animation = "fade",
  arrow = true,
  delay = [100, 100],
  placement = "top",
  tema = "dark",
  theme,
  ...rest
}) => (
  <Tippy
    animation={animation}
    arrow={arrow}
    delay={delay}
    placement={placement}
    theme={theme ?? tema}
    {...rest}
  >
    {children}
  </Tippy>
);

export default Tooltip;
